/**
 * Standard page content wrapper with consistent padding and max-width.
 *
 * @param {object} props
 * @param {string} [props.title]       - Page title displayed at the top
 * @param {React.ReactNode} [props.actions] - Action buttons rendered beside the title
 * @param {string} [props.className]
 */
const PageContainer = ({ title, actions, children, className = '' }) => (
  <main
    className={[
      'flex-1 overflow-y-auto bg-surface-base',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  >
    <div className="mx-auto max-w-7xl px-6 py-8">
      {(title || actions) && (
        <div className="mb-6 flex items-center justify-between">
          {title && (
            <h1 className="text-2xl font-bold text-content">{title}</h1>
          )}
          {actions && <div className="flex items-center gap-3">{actions}</div>}
        </div>
      )}
      {children}
    </div>
  </main>
);

export default PageContainer;
